// @flow
import * as React from "react"
import type { Component } from "recompose"
import { Redirect } from "react-router"

function withRedirect<T>(
  predicate: T => boolean,
  url: string,
): (Component: Component<T>) => Component<T> {
  return Component => props => {
    if (predicate(props)) {
      return <Redirect to={url} />
    }

    return <Component {...props} />
  }
}

export default withRedirect



// WEBPACK FOOTER //
// ./src/hoc/withRedirect.js